'use client';

import useNoticiasPaginaHook from './hook/useNoticiasPaginaHook';

import PaginaPublicacaoTemplateFallback from '@/components/templates/PaginaPublicacaoTemplate/fallback';
import PaginaPublicacaoTemplate, {
  PaginaPublicacaoProps,
} from '@/components/templates/PaginaPublicacaoTemplate';
import RecomendacoesPublicacao from '@/components/organisms/ListagemRecomendacoesPublicacao';

export default function PaginaNoticias(props: PaginaPublicacaoProps) {
  const { $tipoPagina } = props;
  const {
    noticia,
    jsonLDPaginaNoticia,
    noticiaSendoCarregada,
    noticiasRecomendadas,
  } = useNoticiasPaginaHook(props);

  if (!noticia) return <PaginaPublicacaoTemplateFallback />;

  return (
    <PaginaPublicacaoTemplate
      $tipoPublicacao={$tipoPagina}
      $carregandoPublicacao={noticiaSendoCarregada}
      $imagemDestaquePublicacao={noticia.imagemArquivo.urlx1}
      $tituloPublicacao={noticia.titulo}
      $subtituloPublicacao={noticia.subtitulo}
      $tempoLeituraPublicacao={noticia.tempoDeLeitura}
      $autorPublicacaoImagem={noticia?.authorImage}
      $autorPublicacaoNome={noticia.publicadoPor}
      $conteudoPublicacao={noticia?.conteudo}
      $dataPublicacao={noticia.dataNoticia}
      $jsonLDPaginaPublicacao={jsonLDPaginaNoticia}
    >
      {noticiasRecomendadas?.length ? (
        <RecomendacoesPublicacao recomendacoes={noticiasRecomendadas} />
      ) : null}
    </PaginaPublicacaoTemplate>
  );
}
